import React, { useState, useEffect, useContext } from 'react';
import {
  BORDER,
  SELECTED_TAB_KEY,
  USERTYPES,
} from '../../constants/Constants';
import TroubleShootingTab from './TroubleShootingTab';
import {
  auditInitialState,
  auditInitialStateFunc,
  breadCrumbItems,
  calendarStyle,
  errorStudyInitialState,
  searchStyle,
  tabDetails,
  tabDetailsFirmTechnician,
} from './helper/helper';
import CustomBreadCrumb from '../../components/CustomBreadCrumb';
import { useTranslation } from 'react-i18next';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { Tab, TabList } from '@fluentui/react-tabs';
import CustomReportTemplateIcon from '../../components/SVGComponents/CustomReportTemplateIcon';
import { ControlAndSettingsIcon } from '../../components/SVGComponents/ControlAndSettingsIcon';
import { YourReportsIcon } from '../../components/SVGComponents/YourReportsIcon';
import ListViewV2 from '../../components/ListViewV2/ListViewV2';
import loaderContext from '../../context/loader/LoaderContext';
import { SupervisorColumns } from '../../constants/Columns/Supervisor';
import { getSearchedAuditLogList } from '../../service/AuditLogService';
import { t } from 'i18next';
import {
  Calendar,
  SearchBox,
  TextField,
  TooltipHost,
  defaultCalendarStrings,
} from '@fluentui/react';
import Moment from 'moment';
import TabContainer from '../../components/TabContainer/TabContainer';
import { getErrorCodeList } from '../../service/MasterService';
import ErrorCodeTab from '../Masters/ErrorCode/ErrorCodeTab';
import ErrorCodeValueTab from '../Masters/ErrorCode/ErrorCodeValueTab';
import AuditLogListView from './AuditLogListView';
import ErrorStudyListView from './ErrorStudyListView';
import ErrorCodeView from './ErrorCodeView';
import userContext from '../../context/users/UserContext';
import themeContext from '../../context/theme/ThemeContext';
import AiOrchestratorListView from './AiOrchestratorListView';
import IssueTrackerListView from './IssueTrackerListView';
import { getEnv } from '../../helpers/EnvHelper';

const IssuesTroubleShooting = () => {
  const { roles, username, loadByUsername, authenticated } =
    useContext(userContext);
  const { getThemeColor } = useContext(themeContext);
  const [selectedValue, setSelectedValue] = useState(
    SELECTED_TAB_KEY.TROUBLESHOOTING + '1'
  );
  const [errorStudyFilterObj, setErrorStudyFilterObj] = useState(errorStudyInitialState(Moment().format('DD-MMM-YYYY')));
  const [displayListAppliedFilterErrorList, setDisplayListAppliedFilterErrorList] = useState([{label:"From: "+Moment().format('DD-MMM-YYYY')},{label:"To: "+Moment().format('DD-MMM-YYYY')}]);
  const [filterObjErrorList, setFilterObjErrorList] = useState({
    filterInput: null,
    filterUpdate: 0,
  });

  const [auditFilterObj, setAuditFilterObj] = useState(auditInitialStateFunc(Moment().format('DD-MMM-YYYY')));
  const [displayListAppliedFilterAuditLog, setDisplayListAppliedFilterAuditLog] = useState([{label:"From: "+Moment().format('DD-MMM-YYYY')},{label:"To: "+Moment().format('DD-MMM-YYYY')}]);
  const [filterObjAuditLog, setFilterObjAuditLog] = useState({
    filterInput: null,
    filterUpdate: 0,
  });


  useEffect(() => {
    if (!authenticated) {
      console.log('--- Authentication again ----');
      loadByUsername();
      return;
    }
  }, [authenticated]);

  const navigate = useNavigate();
  const [userActionMenuList, setUserActionMenuList] = useState([]);

  const { setLoaderRunning, ref } = useContext(loaderContext);

  const onTabSelect = (event, data) => {
    let currentTab = data.value;
    console.log('currentTab->', currentTab);
    document.getElementById(currentTab).style.border = getThemeColor('border');
    document.getElementById(currentTab).style.borderBottom = 'unset';
    document.getElementById(currentTab).style.borderRadius =
      '10px 10px 0px 0px';
    const tabDetail =
      roles[0] == USERTYPES.ADMIN
        ? tabDetails(selectedValue)
        : tabDetailsFirmTechnician(selectedValue);
    for (let i = 1; i <= tabDetail.length; i++) {
      if (currentTab.charAt(currentTab.length - 1) != i) {
        document.getElementById(
          SELECTED_TAB_KEY.TROUBLESHOOTING + `${i}`
        ).style.border = '';
        document.getElementById(
          SELECTED_TAB_KEY.TROUBLESHOOTING + `${i}`
        ).style.borderRadius = '';
        document.getElementById(
          SELECTED_TAB_KEY.TROUBLESHOOTING + `${i}`
        ).style.borderBottom = '';
      }
    }
    setSelectedValue(data.value);
  };

  useEffect(() => {
    if (
      document.getElementById(SELECTED_TAB_KEY.TROUBLESHOOTING + '1') != null
    ) {
      document.getElementById(
        SELECTED_TAB_KEY.TROUBLESHOOTING + '1'
      ).style.border = getThemeColor('border');
      document.getElementById(
        SELECTED_TAB_KEY.TROUBLESHOOTING + '1'
      ).style.borderBottom = 'unset';
      document.getElementById(
        SELECTED_TAB_KEY.TROUBLESHOOTING + '1'
      ).style.borderRadius = '10px 10px 0px 0px';
    }
  }, [document.getElementById(SELECTED_TAB_KEY.TROUBLESHOOTING + '1')]);

  return (
    <>
      {roles?.length > 0 && (
        <div className="main-container-body">
          <div className="breadCrumb">
            <CustomBreadCrumb items={breadCrumbItems} />
          </div>
          <div
            style={{
              padding: '0px 3px',
              marginTop: '10px',
              boxSizing: 'border-box',
              height: 'calc(100% - 101px)',
            }}
          >
            {
              <TroubleShootTabSection
                onTabSelect={onTabSelect}
                selectedValue={selectedValue}
                tabDetails={
                  roles[0] == USERTYPES.ADMIN
                    ? tabDetails
                    : tabDetailsFirmTechnician
                }
              />
            }
            <div
              style={{
                borderBottom: getThemeColor('border'),
                width: '100%',
                boxSizing: 'border-box',
              }}
            ></div>
            {(roles[0] == USERTYPES.ADMIN
              ? selectedValue == SELECTED_TAB_KEY.TROUBLESHOOTING + '1'
              : false) && (
              <AuditLogListView
                userActionMenuList={userActionMenuList}
                setUserActionMenuList={setUserActionMenuList}
                auditFilterObj={auditFilterObj}
                setAuditFilterObj={setAuditFilterObj}
                displayListAppliedFilter={displayListAppliedFilterAuditLog}
                setDisplayListAppliedFilter={setDisplayListAppliedFilterAuditLog}
                filterObj={filterObjAuditLog}
                setFilterObj={setFilterObjAuditLog}
              />
            )}

            {(roles[0] == USERTYPES.ADMIN
              ? selectedValue == SELECTED_TAB_KEY.TROUBLESHOOTING + '2'
              : selectedValue == SELECTED_TAB_KEY.TROUBLESHOOTING + '1') && (
              <ErrorStudyListView 
              selectedValue={selectedValue} 
              errorStudyFilterObj={errorStudyFilterObj}
              setErrorStudyFilterObj={setErrorStudyFilterObj}
              displayListAppliedFilter={displayListAppliedFilterErrorList}
              setDisplayListAppliedFilter={setDisplayListAppliedFilterErrorList}
              filterObj={filterObjErrorList}
              setFilterObj={setFilterObjErrorList}
              />
            )}

            {(roles[0] == USERTYPES.ADMIN
              ? selectedValue == SELECTED_TAB_KEY.TROUBLESHOOTING + '3'
              : selectedValue == SELECTED_TAB_KEY.TROUBLESHOOTING + '2') && (
              <ErrorCodeView />
            )}
            {(roles[0] == USERTYPES.ADMIN
              ? selectedValue == SELECTED_TAB_KEY.TROUBLESHOOTING + '3'
              : selectedValue == SELECTED_TAB_KEY.TROUBLESHOOTING + '2') && (
              <ErrorCodeView />
            )}
            {(roles[0] == USERTYPES.ADMIN
              ? selectedValue == SELECTED_TAB_KEY.TROUBLESHOOTING + '4'
              : false) && <AiOrchestratorListView />}

            {(roles[0] == USERTYPES.ADMIN && (getEnv("REACT_APP_VDC_PLATFORM") === "true" || getEnv("REACT_APP_VDC_PLATFORM") === true) 
              ? selectedValue == SELECTED_TAB_KEY.TROUBLESHOOTING + '5'
              : false) && <IssueTrackerListView />}
          </div>
        </div>
      )}
    </>
  );
};

export default IssuesTroubleShooting;

const TroubleShootTabSection = ({ onTabSelect, selectedValue, tabDetails }) => {
  const getTabActiveStatus = (tabId) => {
    if (selectedValue === tabId) return true;
    return false;
  };

  return (
    <TabList
      style={{ marginLeft: '10px' }}
      className="tab-list-container-cmp tabList"
      defaultSelectedValue={SELECTED_TAB_KEY.TROUBLESHOOTING + '1'}
      selectedValue={selectedValue}
      onTabSelect={onTabSelect}
    >
      {tabDetails(selectedValue).map((tabElement, index) => {
        return (
          <Tab
            key={index}
            className="top-tab-cmp"
            id={SELECTED_TAB_KEY.TROUBLESHOOTING + (index + 1).toString()}
            value={SELECTED_TAB_KEY.TROUBLESHOOTING + (index + 1).toString()}
          >
            {
              <TroubleShootingTab
                title={tabElement.title}
                icon={tabElement.icon}
                contentClass={tabElement.contentClass}
                active={getTabActiveStatus(tabElement.id)}
              />
            }
          </Tab>
        );
      })}
    </TabList>
  );
};
